import { memo } from "react";

const Route = ({ children }) => children;

export default memo(Route);
